
import React from 'react';
import { useUserReport } from '@/hooks/useUserReport';

const EnergyCostAssessment = () => {
  const { data: report } = useUserReport();

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-xl font-semibold text-[#1F2937] mb-6">Your Energy Cost Assessment</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-[#ECFDF5] rounded-lg p-4">
          <div className="text-center">
            <span className="text-2xl font-bold text-[#111827] block">
              £{report?.tot_ann_sav_pot?.toLocaleString() || 'N/A'}
            </span>
            <p className="text-sm text-gray-600 mt-2">Annual Savings Potential</p>
          </div>
        </div>
        <div className="bg-[#ECFDF5] rounded-lg p-4">
          <div className="text-center">
            <span className="text-2xl font-bold text-[#059669] block">
              £{report?.tot_one_off_cost?.toLocaleString() || 'N/A'}
            </span>
            <p className="text-sm text-gray-600 mt-2">One-Off Cost</p>
          </div>
        </div>
        <div className="bg-[#ECFDF5] rounded-lg p-4">
          <div className="text-center">
            <span className="text-2xl font-bold text-[#111827] block">
              {report?.efficiency_score || 'N/A'}/100
            </span>
            <p className="text-sm text-gray-600 mt-2">KOSI Efficiency Score</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnergyCostAssessment;
